import React from 'react';
import { ResetButton } from './Buttons';

const Controls = props => {
    const {
        hasChoices,
        resetChoices,
    } = props;

    return (
        <ResetButton 
            handleClick={resetChoices}
            isInactive={!hasChoices} />
    );
};

export default Controls;